// @ts-nocheck
import { memo, useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
  Box,
  TextField,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AutoSizer, List } from "react-virtualized"; 
import "./multiselect.scss";

interface SelectWithoutClearButtonProps {
  options: string[];
  label?: string;
  selectedValues: string[];
  onApply: (selected: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MAX_MENU_HEIGHT = ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP;
const MENU_WIDTH = 250;

const SelectWithoutClearButton: React.FC<SelectWithoutClearButtonProps> = ({
  options=[],
  label,
  selectedValues,
  onApply,
  disabled,
  placeholder,
}) => {
  const [tempSelectedOptions, setTempSelectedOptions] = useState<string[]>(selectedValues);
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setTempSelectedOptions(selectedValues);
  }, [selectedValues]);

  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus(); // Focus the input when dropdown opens
    }
  }, [open]);

  const handleSelectChange = (option: string) => {
    // const newSelectedOptions = tempSelectedOptions.includes(option)
    //   ? tempSelectedOptions.filter(item => item !== option)
    //   : [...tempSelectedOptions, option];
    setTempSelectedOptions([option]);
  };

  const handleApply = () => {
    onApply(tempSelectedOptions);
    setOpen(false);
    setSearchQuery(""); // Reset search query on apply
  };

  const handleClose = () => {
    setOpen(false);
    setSearchQuery(""); // Reset search query on close
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const filteredOptions = options ? options?.filter(option =>
    option?.toLowerCase().includes(searchQuery?.toLowerCase())
  ) :[];

  const rowRenderer = ({ index, key, style }: { index: number; key: string; style: React.CSSProperties }) => {
    const option = filteredOptions[index];
    return (
      <MenuItem
        key={key}
        value={option}
        style={style}
        disableRipple
        onClick={() => handleSelectChange(option)}
      >
        <ListItemText primary={option} />
        <Checkbox checked={tempSelectedOptions.includes(option)} />
      </MenuItem>
    );
  };

  return (
    <FormControl fullWidth className="multi-select-wrapper-without-clear">
      {label && <label id="multi-select-label" className={`${disabled ? "disabled" : ""}`}>{label}</label>}
      <Select
        labelId="multi-select-label"
        multiple
        value={tempSelectedOptions}
        IconComponent={ExpandMore}
        onClose={handleClose}
        open={open}
        onOpen={handleOpen}
        disabled={disabled}
        placeholder={placeholder || "Search..."}
        renderValue={(selected) => selected.length ? selected.join(", ") : placeholder}
        className="multi-select-without-clear"
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: MAX_MENU_HEIGHT,
              width: MENU_WIDTH,
            },
            className: "multi-select-wrapper-without-clear",
          },
        }}
      >
        <MenuItem>
          <TextField
            inputRef={inputRef} // Reference to the input
            placeholder={placeholder || "Search..."}
            fullWidth
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
          />
        </MenuItem>
        <AutoSizer disableHeight>
          {({ width }: { width: number }) => (
            <List
              width={width}
              height={Math.min(ITEM_HEIGHT * 4.5, 300)}
              rowCount={filteredOptions.length}
              rowHeight={ITEM_HEIGHT}
              rowRenderer={rowRenderer}
              overscanRowCount={5}
            />
          )}
        </AutoSizer>

        <Box className="flex justify-content-center align-items-center list-footer">
          <Button onClick={handleApply} disabled={tempSelectedOptions?.length < 1} className="primary-medium-green-btn" disableRipple>
            Done
          </Button>
        </Box>
      </Select>
    </FormControl>
  );
};

export default memo(SelectWithoutClearButton);
